module.exports = __webpack_public_path__ + "img/reply_active.a382581a.svg";